<template>
<v-card>
  <v-card-title v-if="title" class='overline py-1' >
    {{title}}
    <v-spacer />
    <v-btn @click="$emit('close')" icon small >
      <v-icon small >mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <request-status :request="req" />

  <v-alert tile
    v-if="req.status === 200"
    type="success" >
    Password has successfully been reset
    <v-btn @click="$emit('close')" text small outlined class="float-right" >Done</v-btn>
  </v-alert>

  <v-card-text>
    User logs in with the email address: <strong>{{memberEmail}}</strong>
    <!-- <pre v-text="member" /> -->
    <v-text-field
      :type="type"
      :append-icon="typeIcon"
      label="new password"
      @click:append="toggleType"
      v-model="req.data.new_password" />

    <v-checkbox
      label="Send login instructions to practitioner "
      v-model="req.data.send_login_instructions" />

  </v-card-text>

  <v-card-actions >
    <v-spacer />
    <v-btn @click="setPassword" color="primary">Reset Password</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>

export default {
  name: 'SetPassword',
  props: {
    title: { type: String, required: false },
    practitioner: { type: Object, required: true }
  },
  data () {
    return {
      type: 'password',
      typeIcon: 'mdi-eye-outline',
      req: {
        resource: 'ag.team',
        extra: 'set_password',
        method: 'post',
        data: {
          new_password: '',
          send_login_instructions: true
        }
      }
    }
  },
  computed: {
    practitionerId() { return this.getObjectPath(this.practitioner, 'user.id') },
    memberEmail () {
      return this.getObjectPath(this.practitioner, 'practitioner.user.email')
    }
  },
  methods: {
    toggleType () {
      if (this.type === 'password') {
        this.type = 'text'
        this.typeIcon = 'mdi-eye-off-outline'
      } else {
        this.type = 'password'
        this.typeIcon = 'mdi-eye-outline'
      }
    },
    setPassword () {
      this.req.data['practitioner'] = this.practitionerId
      this.$request('save', this.req)
    }
  }
}
</script>
